//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ExchangeRatesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type ExchangeRatesGetExchangeRatesExchangeRatesQueryParameters = {
  baseCurrency: string ;
  toCurrencies: string[] ;
}

export function exchangeRatesGetExchangeRatesUrl(baseCurrency: string, toCurrencies: string[]): string {
  let url_ = getBaseUrl() + "/api/exchange-rates?";
  if (baseCurrency === undefined || baseCurrency === null)
    throw new Error("The parameter 'baseCurrency' must be defined and cannot be null.");
  else
    url_ += "BaseCurrency=" + encodeURIComponent("" + baseCurrency) + "&";
  if (toCurrencies === undefined || toCurrencies === null)
    throw new Error("The parameter 'toCurrencies' must be defined and cannot be null.");
  else
    toCurrencies && toCurrencies.forEach(item => { url_ += "ToCurrencies=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let exchangeRatesGetExchangeRatesDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfExchangeRateDto, unknown, Types.ListResultDtoOfExchangeRateDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfExchangeRateDto, unknown, Types.ListResultDtoOfExchangeRateDto>, 'queryFn'>> = {
};
export function getExchangeRatesGetExchangeRatesDefaultOptions() {
  return exchangeRatesGetExchangeRatesDefaultOptions;
};
export function setExchangeRatesGetExchangeRatesDefaultOptions(options: typeof exchangeRatesGetExchangeRatesDefaultOptions) {
  exchangeRatesGetExchangeRatesDefaultOptions = options;
}

export function exchangeRatesGetExchangeRatesQueryKey(dto: ExchangeRatesGetExchangeRatesExchangeRatesQueryParameters): QueryKey;
export function exchangeRatesGetExchangeRatesQueryKey(baseCurrency: string, toCurrencies: string[]): QueryKey;
export function exchangeRatesGetExchangeRatesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { baseCurrency, toCurrencies,  } = params[0] as ExchangeRatesGetExchangeRatesExchangeRatesQueryParameters;

    return trimArrayEnd([
        'ExchangeRatesClient',
        'exchangeRatesGetExchangeRates',
        baseCurrency as any,
        toCurrencies as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExchangeRatesClient',
        'exchangeRatesGetExchangeRates',
        ...params
      ]);
  }
}
export function __exchangeRatesGetExchangeRates(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.exchangeRatesGetExchangeRates(
      context.queryKey[2] as string,       context.queryKey[3] as string[],axiosConfig    );
}

export function useExchangeRatesGetExchangeRatesQuery<TSelectData = Types.ListResultDtoOfExchangeRateDto, TError = unknown>(dto: ExchangeRatesGetExchangeRatesExchangeRatesQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfExchangeRateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useExchangeRatesGetExchangeRatesQuery<TSelectData = Types.ListResultDtoOfExchangeRateDto, TError = unknown>(baseCurrency: string, toCurrencies: string[], options?: Omit<UseQueryOptions<Types.ListResultDtoOfExchangeRateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useExchangeRatesGetExchangeRatesQuery<TSelectData = Types.ListResultDtoOfExchangeRateDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfExchangeRateDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let baseCurrency: any = undefined;
  let toCurrencies: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ baseCurrency, toCurrencies,  } = params[0] as ExchangeRatesGetExchangeRatesExchangeRatesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [baseCurrency, toCurrencies, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfExchangeRateDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __exchangeRatesGetExchangeRates(context, axiosConfig) : __exchangeRatesGetExchangeRates,
    queryKey: exchangeRatesGetExchangeRatesQueryKey(baseCurrency, toCurrencies),
    ...exchangeRatesGetExchangeRatesDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfExchangeRateDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setExchangeRatesGetExchangeRatesData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfExchangeRateDto | undefined) => Types.ListResultDtoOfExchangeRateDto, baseCurrency: string, toCurrencies: string[]) {
  queryClient.setQueryData(exchangeRatesGetExchangeRatesQueryKey(baseCurrency, toCurrencies),
    updater
  );
}

/**
 * @return OK
 */
export function setExchangeRatesGetExchangeRatesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfExchangeRateDto | undefined) => Types.ListResultDtoOfExchangeRateDto) {
  queryClient.setQueryData(queryKey, updater);
}